import { CandidateChecklistItem } from "src/app/models/models";

/** Router commands for an Action Center row. Null when the row has no destination. */
export function checklistItemCommands(item: CandidateChecklistItem): string[] | null {
	if (item.taskType === "standalone_feedback" && item.taskId) {
		return ["/checklist/feedback", item.taskId];
	}
	if (item.taskType === "feedback" && item.trainingAssessmentId) {
		return ["/checklist", item.trainingAssessmentId, "feedback"];
	}
	if (item.trainingAssessmentId) {
		return ["/checklist", item.trainingAssessmentId];
	}
	return null;
}
